<app-modal-layout
    [containerLayout]="containerLayout"
    (closeModal)="forceWithValidation()"
    *transloco="let tStatusConfiguration; read: 'status_configuration'"
>
    <ng-container title>{{ tStatusConfiguration('status_configuration') }}</ng-container>
    <ng-container subtitle>{{
        tStatusConfiguration('status_configuration_description')
    }}</ng-container>
    <app-tb-tabs
        class="border-b-2 border-neutral4 border-solid"
        [tabs]="data.schemaTabs"
        [activeTab]="selectedSOT"
        (tabOpened)="changeTab($event)"
    ></app-tb-tabs>

    <div class="flex max-sm:flex-col mb-10 body-1">
        <div *appEnv="'prod'; visible: false" class="sm:mr-4">
            <app-template-selector></app-template-selector>
        </div>

        <app-status-select-cell-settings
            [field]="currentStatus"
            [selectOptions]="selectObjectOptions"
            [template]="true"
            (fieldChanged)="fieldChanged($event)"
        ></app-status-select-cell-settings>
    </div>
    <app-modal-layout-buttons
        buttons
        [cancel]="true"
        [primary]="true"
        *transloco="let tButtons; read: 'buttons'"
    >
        <app-tb-button cancel (click)="goBack()" [appearance]="'outlined'" class="mr-4">
            {{ tButtons('cancel') }}
        </app-tb-button>
        <app-tb-button (click)="applyChanges()" primary> {{ tButtons('apply') }} </app-tb-button>
    </app-modal-layout-buttons>
</app-modal-layout>
